import React, { useState } from 'react';
import { PDFDocument } from 'pdf-lib';

export const JpgToPdfView: React.FC = () => {
  const [files, setFiles] = useState<File[]>([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConvert = async () => {
    if (files.length === 0) {
      setError("Please select at least one JPG image.");
      return;
    }
    setIsProcessing(true);
    setError(null);
    try {
      const pdf = await PDFDocument.create();
      
      for (const file of files) {
        const arrayBuffer = await file.arrayBuffer();
        let image;
        if (file.type === 'image/jpeg' || file.type === 'image/jpg') {
          image = await pdf.embedJpg(arrayBuffer);
        } else if (file.type === 'image/png') {
          image = await pdf.embedPng(arrayBuffer);
        } else {
          continue; // skip unsupported
        }
        
        const page = pdf.addPage([image.width, image.height]);
        page.drawImage(image, {
          x: 0,
          y: 0,
          width: image.width,
          height: image.height,
        });
      }
      
      const pdfBytes = await pdf.save();
      const blob = new Blob([pdfBytes as unknown as BlobPart], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'converted_images.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, padding: '1rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <div>
          <h2 style={{ margin: 0 }}>JPG to PDF</h2>
          <p style={{ margin: '0.25rem 0 0', color: 'var(--color-text-secondary)' }}>Convert your images (JPG, PNG) into a single PDF document.</p>
        </div>
        <button onClick={() => { void handleConvert(); }} disabled={isProcessing} style={{ padding: '0.5rem 1rem', background: 'var(--color-accent)', color: 'var(--color-on-accent)', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 600 }}>
          {isProcessing ? 'Converting...' : 'Convert to PDF'}
        </button>
      </div>
      {error && <div style={{ color: 'red', marginBottom: '1rem', padding: '0.5rem', background: '#ffebee', borderRadius: '4px' }}>{error}</div>}
      
      <div style={{ flex: 1, border: '2px dashed var(--color-border)', borderRadius: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
        <input 
          type="file" 
          accept="image/jpeg, image/png" 
          multiple
          onChange={(e) => {
            if (e.target.files) {
              setFiles(Array.from(e.target.files));
              setError(null);
            }
          }}
          style={{ marginBottom: '1rem' }}
        />
        {files.length > 0 && (
          <ul style={{ listStyleType: 'none', padding: 0, textAlign: 'left', width: '100%', maxWidth: '400px', maxHeight: '200px', overflowY: 'auto' }}>
            {files.map((f, i) => (
              <li key={i} style={{ padding: '0.5rem', borderBottom: '1px solid var(--color-border)' }}>
                {i + 1}. {f.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
